import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class AccountingBookService extends DatabaseGwService {
  URL_PATH="/acc-books";
}
